export interface PremiumFlags {
  isAppPremium?: boolean;
  isPersonalPremium?: boolean;
}

export interface PremiumSubscriptionState {
  isPaidPremium: boolean;
  isPremium: boolean;
  subscriptionInfo: any | false;
}

export interface PremiumAccessInput {
  hasFullPremium: boolean;
  hasBasicMembership: boolean;
  isAdmin?: boolean;
}

export interface PremiumAccessState {
  hasFullPremium: boolean;
  hasChatAccess: boolean;
  canSkipTravelModal: boolean;
  canHideAds: boolean;
  canCreateServiceOffers: boolean;
}

export function activePremiumSubscriptionFromSnapshot(snapshot: any) {
  const docs = snapshot?.docs || [];
  const doc = docs.find?.((item: any) => {
    const data = item?.data?.();
    return (
      data?.role === 'premium' &&
      ['trialing', 'active'].includes(data?.status)
    );
  });
  const subscriptionInfo = doc?.data?.();

  return subscriptionInfo || false;
}

export function premiumStateFromSubscriptionSnapshot(
  snapshot: any,
  flags: PremiumFlags = {}
): PremiumSubscriptionState {
  const subscriptionInfo = activePremiumSubscriptionFromSnapshot(snapshot);
  const isPaidPremium = !!subscriptionInfo;

  return {
    isPaidPremium,
    isPremium: !!(
      flags.isPersonalPremium ||
      flags.isAppPremium ||
      isPaidPremium
    ),
    subscriptionInfo,
  };
}

export function premiumAccessState(
  input: PremiumAccessInput
): PremiumAccessState {
  const hasFullPremium = !!(input.hasFullPremium || input.isAdmin);

  return {
    hasFullPremium,
    hasChatAccess: hasFullPremium || !!input.hasBasicMembership,
    canSkipTravelModal: hasFullPremium,
    canHideAds: hasFullPremium,
    canCreateServiceOffers: hasFullPremium,
  };
}
